module.exports = window["llms"]["icons"];